import { css } from '@emotion/react'

const menu = theme => css`
  [role='menuitem'] {
    &.active,
    &:hover {
      .menu-item-icon {
        background-color: rgba(${theme.color.monochrome.white_rgba}, 0.6);
      }
    }
  }
`

export const styles = {
  menu,
}
